// src/pages/Home.tsx
import React, { useContext, useEffect, useState } from 'react';
import MenuBar from '../components/Navbar'; // Import from components
import Button from '../components/Button';   // Reusable button component
import { useNavigate } from 'react-router-dom';
import { UserRoleContext } from '../context/UserRoleContext';
import { EventContext } from '../context/EventContext';
import { ROUTES } from '../constants/routes';
import RegistrantDetail from '../components/IndividualRegistrantComponent';
import { getRolesByUserId } from '../services/userRoleService';
import { UserRole } from '../types/UserRole';
import { useAuth } from '../context/AuthContext';

const ChooseHostComponnt: React.FC = () => {
    const navigate = useNavigate();
    const { userRole, setUserRole } = useContext(UserRoleContext);
    const { currentEvent } = useContext(EventContext);

    const [userRoles, setUserRoles] = useState<UserRole[]>([]);

    const { signOut, isAuthenticated, user } = useAuth();




    const fetchRoles = async () => {
        try {
            if (user?.userId) {
                const roles = await getRolesByUserId(user.userId);
                if (roles.length > 0) {
                    const filteredRoles = roles.filter(role => (role.host_id && role.host_id != '' && role.role_id == 'ADMIN'));
                    const matchedRole = roles.find(role => role.user_role_id === userRole?.user_role_id);
                    setUserRoles(filteredRoles);

                    if (matchedRole) {
                        setUserRole(matchedRole);
                    } else if (roles.length == 1) {
                        setUserRole(roles[0]);
                    }
                }
            }
        } catch (error) {
            console.error('Failed to fetch user roles:', error);
        }
    };

    useEffect(() => {
        if (isAuthenticated) {
            fetchRoles();
        } else {
            navigate(ROUTES.HOME);
        }
    }, [isAuthenticated]);

    const checkmarkStyle = {
        bottom: '10px',
        right: '10px',
        color: '#FFFFFF',//'#4CAF50', // Same color as the border to keep it cohesive
        fontStyle: 'italic',
        display: 'flex',
        alignItems: 'center',
        gap: '5px', // Spacing between checkmark and text
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <h2 style={{ fontSize: 'clamp(20px, 36px, 40px)', flexDirection: 'row', whiteSpace: 'nowrap' }}>Who's Hosting Your Event</h2>
            <div style={styles.splitPanel}>

                <div className='card' style={styles.panel}>
                    <h2 style={{margin: '5px'}}>Quick Select</h2>
                    {userRoles.length > 0 ? (
                        userRoles.map((role) => (
                            <button
                                key={role.user_role_id}
                                style={{
                                    ...styles.createButton,
                                    ...(userRole?.user_role_id === role?.user_role_id
                                        ? { border: '3px solid #007acc' } // green border when selected
                                        : {})
                                }}
                                onClick={() => {
                                    setUserRole(role);
                                }}
                            ><span style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                                    {role.host_name || 'Unnamed Host'}
                                    {userRole?.user_role_id === role?.user_role_id && (
                                        <div style={checkmarkStyle}>
                                            <span>&#10003;</span> {/* Checkmark symbol */}
                                            <span>Selected</span>
                                        </div>
                                    )}
                                </span>
                            </button>
                        ))
                    ) : (
                        <p>No available hosts found.</p>
                    )}

                    <h2 style={{paddingBottom: '0px', marginBottom: '0px'}}>OR</h2>
                    <button style={{...styles.createButton}} onClick={() => navigate(ROUTES.HOST_ORG_OVERVIEW)}>Setup a New Host</button>

                    <button style={{...styles.createButton, ...{ marginTop: '60px'}}} disabled={!userRole?.host_id} onClick={() => navigate(ROUTES.CREATE_EVENT)}>Continue <span>&#x2b95;</span></button>
                    <button className='cancelButton' style={{ marginTop: '20px'}} onClick={() => navigate(ROUTES.HOME)}>Cancel</button>


                </div>
            </div>

        </div>

    );

};

const styles = {
    dashboardContainer: {
        display: 'flex',
    },
    contentContainer: {
        padding: '20px',
        flex: 1,
    },
    splitPanel: {
        display: 'flex',
        flexDirection: 'row',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: '30px'
    } as React.CSSProperties,
    panel: {
        width: '45%',
        minWidth: '350px',
        padding: '20px',
        border: '1px solid #ccc',
        placeItems: 'center',
        maxWidth: '500px'
    },
    createButton: {
        width: '100%',
        padding: '10px',
        marginTop: '20px',
        cursor: 'pointer',
        fontSize: '20px',
        minWidth: '300px',
        minHeight: '50px',
        whiteSpace: 'normal'
    }
};

export default ChooseHostComponnt;
